import { render, staticRenderFns } from "./detailsSection.vue?vue&type=template&id=8096da50&"
import script from "./detailsSection.vue?vue&type=script&lang=js&"
export * from "./detailsSection.vue?vue&type=script&lang=js&"
import style0 from "./detailsSection.vue?vue&type=style&index=0&id=8096da50&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports